export default "/images/9d9d3bc1f56019c51f401a69fa212297.avif";